<template>
  <div class="container-fluid px-5 mt-4">

    <!-- Uvítací nadpis -->
    <div class="row mb-4">
      <div class="col-12">
        <h1 class="dashboard-welcome">{{ $t('dashboard.welcome_back') }}</h1>
      </div>
    </div>

    <!-- Akční boxy — vytvoření a ověření certifikátu -->
    <div class="dashboard-actions-wrap mb-4">
      <div class="d-flex gap-4">

        <!-- Přechod na stránku vytvoření certifikátu -->
        <div class="dashboard-action-box dashboard-action-box--clickable" @click="$router.push({ name: 'CertCreate' })">
          <div class="dashboard-action-box__icon">
            <img :src="iconPlus" alt="" class="icon-blue">
          </div>
          <div class="dashboard-action-box__content">
            <p class="dashboard-action-box__title">{{ $t('dashboard.action_create') }}</p>
            <p class="dashboard-action-box__sub">{{ $t('dashboard.action_create_sub') }}</p>
          </div>
        </div>

        <!-- Přechod na stránku ověření certifikátu -->
        <div class="dashboard-action-box dashboard-action-box--clickable" @click="$router.push({ path: '/verification' })">
          <div class="dashboard-action-box__icon">
            <img :src="iconMagnifying" alt="">
          </div>
          <div class="dashboard-action-box__content">
            <p class="dashboard-action-box__title">{{ $t('dashboard.action_search') }}</p>
            <p class="dashboard-action-box__sub">{{ $t('dashboard.action_search_sub') }}</p>
          </div>
        </div>

      </div>
      <div v-if="false" class="dashboard-actions-warning">
        <img :src="iconWarning" alt="" class="dashboard-actions-warning__icon">
        <span class="dashboard-actions-warning__badge">{{ notificationsCount }}</span>
      </div>
    </div>

    <!-- Systémová upozornění — neúplný profil -->
    <div class="row">
      <div v-if="showHowToCreateCertificate" class="col-12 mb-3">
        <div class="dashboard-notice dashboard-notice--info">
          <div class="dashboard-notice__text">
            <div class="">1. {{ $t('dashboard.stepsToCreate_1') }}</div>
            <router-link :to="{ name: 'ClientProfile' }" class="dashboard-notice__btn">
              {{ $t('dashboard.fillProfile') }}<i class="bi bi-arrow-right ms-1"></i>
            </router-link>
          </div>
          <div class="dashboard-notice__text mt-2">2. {{ $t('dashboard.stepsToCreate_2') }}</div>
          <div class="dashboard-notice__text mt-2">3. {{ $t('dashboard.stepsToCreate_3') }}</div>
        </div>
      </div>
      <div v-if="!isLoading && !isAllDataForCert && !showHowToCreateCertificate" class="col-12 mb-3">
        <div class="dashboard-notice dashboard-notice--warning">
          <div class="dashboard-notice__title">{{ $t('dashboard.profileIsNotComplete') }}</div>
          <div class="dashboard-notice__text">{{ $t('dashboard.forGeneratingCertFillProfile') }}</div>
          <router-link :to="{ name: 'ClientProfile' }" class="dashboard-notice__btn mt-2 d-inline-flex">
            {{ $t('dashboard.fillProfile') }}<i class="bi bi-arrow-right ms-1"></i>
          </router-link>
        </div>
      </div>
    </div>

    <!-- Seznam certifikátů uživatele -->
    <div class="row">
      <div class="col-12 mb-3">
        <SharedCertsListComponent></SharedCertsListComponent>
        <CertsListComponent></CertsListComponent>
      </div>
    </div>

  </div>
</template>

<script>
import http from "../http";
import iconPlus from '/public/img/new-design/icons/plus.svg';
import iconMagnifying from '/public/img/new-design/icons/magnifying.svg';
import iconWarning from '/public/img/new-design/icons/warning.svg';
import { loadingState } from '@/loading.js';

const EMPTY_CLIENT = {
  name: '',
  email: '',
  address: { line_1: '', line_2: '', city: '', country_code: '', postal_code: '' },
  verification: { document_type: '', document_number: '', expiration_date: '' },
};

export default {
  data() {
    return {
      client: {
        address: { line_1: '', line_2: '', city: '', country_code: '', postal_code: '' },
        verification: { document_type: '', document_number: '', expiration_date: '' },
      },
      isLoading: false,
      showHowToCreateCertificate: false,
      notificationsCount: 3,
      iconPlus,
      iconMagnifying,
      iconWarning,
    };
  },

  mounted() {
    this.getAuthClient();
    if (this.$route.query.showHowToCreateCertificate) {
      this.showHowToCreateCertificate = this.$route.query.showHowToCreateCertificate;
    }
  },

  computed: {
    isName() {
      return this.client.name && this.client.name.length !== 0;
    },
    isAddress() {
      return this.client.address.line_1.length !== 0 && this.client.address.city.length !== 0 && this.client.address.postal_code.length !== 0;
    },
    isAllVerificationData() {
      return this.client.verification && this.client.verification.document_type?.length !== 0 && this.client.verification.document_number?.length !== 0 && this.client.verification.expiration_date?.length !== 0;
    },
    isAllDataForCert() {
      return this.isName && this.isAddress && this.isAllVerificationData;
    },
  },

  methods: {
    getAuthClient() {
      let self = this;
      self.isLoading = true;
      http.get('/get-auth-client').then((response) => {
        self.client = response.data.client;
        if (!response.data.client.address) self.client.address = { ...EMPTY_CLIENT.address };
        if (!response.data.client.verification) self.client.verification = { ...EMPTY_CLIENT.verification };
        self.isLoading = false;
        loadingState.active = false;
      });
    },
  },
};
</script>